(ns frontend.ux-overhaul.view-configuration.subs
  (:require
   [common.opensearch.access :as os-access]
   [common.schema.listing-definition :as listing-definition]
   [common.schema.registry :as registry]
   [common.schema.system :as schema-system]
   [frontend.react.virtualized.scrollable-grid.common :as common-grid]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.view-configuration.common :refer [view-configuration-path]]
   [frontend.view.grid.tasks-grid.events :as tasks-grid]
   [re-frame.core :refer [reg-sub]]))

(defn- root-attribute
  [field-path]
  (cond
    (keyword? field-path) field-path
    (and (vector? field-path)
         (= 1 (count field-path))) (first field-path)
    (and (sequential? field-path)
         (= 1 (count field-path))) (first field-path)
    :else nil))

(defn- field-attribute-universe
  [entity-type]
  (let [accessible-attributes (->> (os-access/accessible-dedicated-os-fields
                                    {:tenant                      @session/tenant
                                     :tenant-schema               @session/tenant-schema
                                     :account                     @session/account
                                     :role                        @session/role
                                     :account-current-permissions (:account/current-permissions @session/account)
                                     :pipeline-id                 nil
                                     :entity-type                 entity-type})
                                   (keep (comp root-attribute :field-path))
                                   (remove schema-system/hidden-system-field-attribute?)
                                   (remove #{:common/display-name})
                                   set)
        default-order (->> (listing-definition/default-columns entity-type)
                           (keep root-attribute))
        schema-order (->> (registry/get-schema @session/tenant-schema entity-type)
                          keys)]
    (->> (concat default-order schema-order accessible-attributes)
         (filter accessible-attributes)
         distinct
         vec)))

(defn- resolve-column-key-universe
  [entity-type]
  (when entity-type
    (case entity-type
      :entity.type/task (tasks-grid/resolve-column-key-universe)
      (field-attribute-universe entity-type))))

(reg-sub
 ::view-configuration
 (fn [db]
   (get-in db view-configuration-path)))

(reg-sub
 ::entity-attributes
 :<-
 [::view-configuration]
 (fn [view-config]
   (let [entity-type (:entity-type view-config)
         column-universe (resolve-column-key-universe entity-type)]
     column-universe)))

(reg-sub
 ::sortable-attributes
 :<-
 [::view-configuration]
 (fn [config]
   (let [entity-type (:entity-type config)
         column-universe (resolve-column-key-universe entity-type)]
     column-universe)))

(reg-sub
 ::groupable-attributes
 :<-
 [::view-configuration]
 (fn [config]
   (let [entity-type (:entity-type config)
         columns (resolve-column-key-universe entity-type)
         groupable-attributes (->> columns
                                   (filter common-grid/groupable-attribute?)
                                   (vec))]
     groupable-attributes)))

(reg-sub
 ::unsaved-changes?
 :<-
 [::view-configuration]
 :unsaved-changes?)
